import { render, staticRenderFns } from "./historyComissions.vue?vue&type=template&id=3378619d&scoped=true"
import script from "./historyComissions.vue?vue&type=script&lang=js"
export * from "./historyComissions.vue?vue&type=script&lang=js"
import style0 from "./historyComissions.vue?vue&type=style&index=0&id=3378619d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3378619d",
  null
  
)

export default component.exports